import { useQuery } from '@tanstack/react-query'

import { QUERY_KEYS } from '@/lib/queryKeys'

import { getPaymentSummary } from '../paymentsService'
import { PaymentSummaryPayload } from '../types/PaymentSummaryPayload'
import { PaymentSummaryResponse } from '../types/PaymentSummaryResponse'

export const usePaymentSummary = ({
  pkgId,
  isInsuranceAdded,
  couponCode,
  creditToUseUSD,
  shippingMethod,
  enabled = true,
}: PaymentSummaryPayload & { enabled?: boolean }) => {
  return useQuery<PaymentSummaryResponse>({
    queryKey: [QUERY_KEYS.PACKAGE_PAYMENTS_SUMMARY, pkgId, isInsuranceAdded, couponCode ?? '', creditToUseUSD ?? 0, shippingMethod],
    queryFn: () =>
      getPaymentSummary({
        pkgId: pkgId!,
        isInsuranceAdded,
        couponCode,
        creditToUseUSD,
        shippingMethod,
      }),
    enabled: enabled && !!pkgId && !!shippingMethod,
    keepPreviousData: true,
    refetchOnMount: true,
  })
}
